// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SHARE_BUTTON_LABEL = "Sd\u00edlej";
